import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from 'components/custom';
import { SouthEast } from '@mui/icons-material';
import { List, ListItem, ListItemText, Typography } from '@mui/material';
const OverwriteLessonsDialog = (props) => {
    const { t } = useTranslation('coursePlanning', {
        keyPrefix: 'overwriteConfirmationDialog',
    });
    const handleClose = () => {
        props.setData(null);
    };
    const handleChoice = (overwriteObjects) => {
        if (props.data) {
            props.sendTransferLessonsToServer(props.data.transferData, overwriteObjects);
        }
        props.setData(null);
    };
    const isSingleLesson = props.data?.lessonsToConfirm.length === 1;
    return (_jsxs(Dialog, { open: !!props.data, onClose: handleClose, titleProps: {
            Icon: SouthEast,
            text: t('title'),
        }, actions: [
            _jsx(Button, { fullWidth: true, variant: "contained", color: "error", onClick: handleClose, children: t('button.cancel') }, "cancel"),
            _jsx(Button, { fullWidth: true, variant: "contained", color: "primary", onClick: () => {
                    handleChoice(true);
                }, children: isSingleLesson
                    ? t('button.overwriteSingle')
                    : t('button.overwriteMultiple') }, "overwrite"),
            _jsx(Button, { fullWidth: true, variant: "contained", color: "secondary", onClick: () => {
                    handleChoice(false);
                }, children: isSingleLesson
                    ? t('button.appendSingle')
                    : t('button.appendMultiple') }, "append"),
        ], children: [isSingleLesson ? t('textSingle') : t('textMultiple'), _jsx(List, { children: props.data?.lessonsToConfirm.map((lessonDate, index) => (_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { sx: { color: 'text.secondary', paddingLeft: '1rem' }, children: lessonDate }) }, index))) }), _jsx(Typography, { children: t('question') })] }));
};
export default OverwriteLessonsDialog;
